import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Address } from '../../models/address';
import { DatePipe, formatDate } from '@angular/common';

declare var $: any;
declare var envconfig: any;

@Injectable({
  providedIn: 'root'
})
export class ForuscareService {

  APP_VERSION = "v11.3.0";

  IDLE_TIMEOUT = 1800; /* time in seconds */

  /*------STGTELEEYE------*/
  public hostUrl = "https://stgteleeyeadmin.foruscare.com";
  public aiHostUrl = "https://stagingadmin.foruscare.com";
  public qrCodeUrl = "https://qrstgteleeye.fhtelecare.com/qrd";
  public customerOnboardingURL = "https://customeronboardingdev.fhtelecare.com/forus-onboarding-service";
  public spectacleURL = "https://spectacledev.fhtelecare.com//forus-spectacle-service";
  private logsOn: boolean = envconfig.LOGS_ON ? true : false;
  private debugOn: boolean = envconfig.DEBUG_ON ? true : false;;
  private activeENV: any = envconfig;

  constructor() {
    if (this.activeENV) {
      switch (this.activeENV.ACTIVE_ENV) {
        case 'LIVE': /*------LIVE------*/
          this.hostUrl = "https://admin.foruscare.com";
          this.aiHostUrl = "https://admin.foruscare.com";
          this.qrCodeUrl = "https://qr.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://onboarding.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectacle.foruscare.com//forus-spectacle-service";
          break;
        case 'US': /*------US------*/
          this.hostUrl = "https://adminus.fhtelecare.com";
          this.aiHostUrl = "https://adminus.fhtelecare.com";
          this.qrCodeUrl = "https://qrus.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingus.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectacleus.foruscare.com//forus-spectacle-service";
          break;
        case 'DEV': /*------GENERIC DEV------*/
          this.hostUrl = "https://admindev.foruscare.com";
          this.aiHostUrl = "https://admindev.foruscare.com";
          this.qrCodeUrl = "https://qrstaging.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingstaging.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectaclestaging.fhtelecare.com//forus-spectacle-service";
          break;
        case 'STAGING': /*------STAGING------*/
          this.hostUrl = "https://stagingadmin.foruscare.com";
          this.aiHostUrl = "https://stagingadmin.foruscare.com";
          this.qrCodeUrl = "https://qrstaging.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingstaging.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectaclestaging.fhtelecare.com//forus-spectacle-service";
          break;
        case 'STGTELEEYE': /*------STGTELEEYE------*/
          this.hostUrl = "https://stgteleeyeadmin.foruscare.com";
          this.aiHostUrl = "https://stagingadmin.foruscare.com";
          this.qrCodeUrl = "https://qrstgteleeye.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingdev.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectacledev.fhtelecare.com//forus-spectacle-service";
          break;
        case 'UAT': /*------UAT------*/
          this.hostUrl = "https://uat.fhtelecare.com";
          this.aiHostUrl = "https://uat.fhtelecare.com";
          this.qrCodeUrl = "https://qruat.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingstaging.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectaclestaging.fhtelecare.com//forus-spectacle-service";
          break;
        case 'DEMO': /*------DEMO------*/
          this.hostUrl = "https://demo.fhtelecare.com";
          this.aiHostUrl = "https://demo.fhtelecare.com";
          this.qrCodeUrl = "https://qrstaging.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingstaging.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectaclestaging.fhtelecare.com//forus-spectacle-service";
          break;
        case 'PUNJAB_GOV': /*------PUNJAB GOVERNAMENT------*/
          this.hostUrl = "https://actprojectadmin.fhtelecare.com";
          this.aiHostUrl = "https://actprojectadmin.fhtelecare.com";
          this.qrCodeUrl = "https://qractprojectadmin.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingactprojectadmin.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectacleactprojectadmin.fhtelecare.com//forus-spectacle-service";
          break;
        default: /*------GENERIC DEV------*/
          this.hostUrl = "https://admindev.foruscare.com";
          this.aiHostUrl = "https://admindev.foruscare.com";
          this.qrCodeUrl = "https://qrstaging.fhtelecare.com/qrd";
          this.customerOnboardingURL = "https://customeronboardingstaging.fhtelecare.com/forus-onboarding-service";
          this.spectacleURL = "https://spectaclestaging.fhtelecare.com//forus-spectacle-service";
      }
      this.logSticker('\u{25B6}', '#16A085', 'white', "Active ENV : " + this.activeENV.ACTIVE_ENV);
      if (this.activeENV.LOGS_ON) {
        this.logSticker('\u{25C9}', '#DC7633', 'white', "Logger On ");
      }
      if (this.activeENV.DEBUG_ON) {
        this.logSticker('\u{25C9}', '#DC7633', 'white', "Debugger On ");
      }
    }
  }

  logSticker(iconHexCode: any, backgroundColor: any, fontColor: any, msg: any) {
    console.log("%c " + iconHexCode + " " + msg, "background-color:" + backgroundColor + ";color:" + fontColor + ";font-weight:bold;padding:5px;border-radius:5px");
  }

  getCurrentUTCDateTime() {
    let d = new Date();
    return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()));
  }

  baseAuthURL(): string {
    return this.hostUrl + '/AP-foruscare-service';
  };
  caseServiceURL(): string {
    return this.hostUrl + '/AP-foruscare-case-service';
  };
  baseAdminURL(): string {
    return this.baseAuthURL() + '/admin';
  };

  baseTelecareURL(): string {
    return this.hostUrl + "/telecare";
  };

  basehostUrl(): string {
    return this.hostUrl;
  };

  convertUTCtoLocal(date): string {
    var dateString = "";
    if (date != null) {
      var dateVal = new Date(date);
      var utcToLocal = new Date(Date.UTC(dateVal.getFullYear(), dateVal.getMonth(), dateVal.getDate(), dateVal.getHours(), dateVal.getMinutes(), dateVal.getSeconds()));
      dateString = (utcToLocal.toLocaleDateString("en-GB") + ", " + utcToLocal.toLocaleTimeString());
    }
    return dateString;
  };

  getUserRoles(): any {
    return [
      { id: "ROLE_OPTHALMOLOGY_SUPERVISOR", itemName: "Reading Center Manger" },
      { id: "ROLE_OPHTHALMOLOGY_EXPERT", itemName: "Expert" },
      { id: "ROLE_PROGRAM_LEAD", itemName: "Account Admin" },
      { id: "ROLE_CLUSTER_LEAD", itemName: "Screening Center Manger" },
      { id: "ROLE_ORGANIZATION", itemName: "Operator" },
      { id: "ROLE_OPERATIONAL_ADMIN", itemName: "Operational Admin" },
      { id: "ROLE_EYE_MITRA", itemName: "Eye Mitra" },
      { id: "ROLE_EYE_CONNECT", itemName: "Eye Connect" },
      { id: "ROLE_HOSPITAL_OPERATOR", itemName: "Refferal Hospital User" },
      { id: "ROLE_QUALITY_OFFICER", itemName: "Quality Officer" }
    ]
  }

  AI_ASSISTANCE = "ASSISTIVE";
  AI_AUTONOMOUS = "AUTONOMOUS";
  SUBSCRIPTION_POSTPAID = 2;
  SUBSCRIPTION_PREPAID = 1;

  getAavailableAIFlows(): any {
    return [
      { id: this.AI_ASSISTANCE, itemName: 'Assistive' },
      { id: this.AI_AUTONOMOUS, itemName: 'Autonomous' }
    ];
  }

  RESPONSE_STATUS = 200;

  RESULT_SUCCESS = 'Success';
  RESULT_ERROR = 'Failure';
  ROLE_ORGANIZATION = "ROLE_ORGANIZATION";
  ROLE_FINANCE = "ROLE_FINANCE";
  ROLE_MANAGEMENT = "ROLE_MANAGEMENT";
  ROLE_ADMIN = "ROLE_ADMIN";
  ROLE_PROGRAM_LEAD = "ROLE_PROGRAM_LEAD";
  ROLE_OPTHALMOLOGY_SUPERVISOR = "ROLE_OPTHALMOLOGY_SUPERVISOR";
  ROLE_CLUSTER_LEAD = "ROLE_CLUSTER_LEAD";
  ROLE_PROGRAM_MANAGER = "ROLE_PROGRAM_MANAGER";
  ROLE_QUALITY_AUDITOR = "ROLE_QUALITY_AUDITOR";
  ROLE_OPERATION = "ROLE_OPERATION";
  ROLE_REVIEWER = "ROLE_REVIEWER";
  ROLE_APPROVER = "ROLE_APPROVER";
  ROLE_TEAMOWNER = "ROLE_TEAMOWNER";
  ROLE_OPHTHALMOLOGY_EXPERT = "ROLE_OPHTHALMOLOGY_EXPERT";
  ROLE_SPECTACLE_ADMIN = "ROLE_SPECTACLE_ADMIN";
  ROLE_SPECTACLE_SUPERVISOR = "ROLE_SPECTACLE_SUPERVISOR";
  ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
  ROLE_TELE_OPTOMETRIST = "ROLE_TELE_OPTOMETRIST";
  ROLE_OPERATIONAL_ADMIN = "ROLE_OPERATIONAL_ADMIN";
  ROLE_HOSPITAL_OPERATOR = "ROLE_HOSPITAL_OPERATOR";

  SERVICE_READING_CENTER = "SERVICE_READING_CENTER";
  SERVICE_SPECTACLE = "SERVICE_SPECTACLE";
  SERVICE_AI = "SERVICE_AI";
  SERVICE_TELE_REFRACTION = "SERVICE_TELE_REFRACTION";
  ROLE_EYE_MITRA = "ROLE_EYE_MITRA";
  ROLE_EYE_CONNECT = "ROLE_EYE_CONNECT";
  ROLE_QUALITY_OFFICER = "ROLE_QUALITY_OFFICER"

  getServiceProviderCategories() {
    return [
      { categoryId: this.SERVICE_READING_CENTER, categoryName: 'Reading Center' },
      { categoryId: this.SERVICE_SPECTACLE, categoryName: 'Spectacle Provider' },
      { categoryId: this.SERVICE_AI, categoryName: 'AI Provider' },
      { categoryId: this.SERVICE_TELE_REFRACTION, categoryName: 'Tele Refraction' }
    ];
  }

  getAIModeByKey(key): string {
    if (key == this.AI_ASSISTANCE)
      return "Assistive";
    else if (key == this.AI_AUTONOMOUS)
      return "Autonomous";
  }

  getRoleNameUsingKey(key): string {
    let role;
    switch (key) {
      case this.ROLE_ADMIN:
        return "Account Admin";
      case this.ROLE_PROGRAM_LEAD:
        return "Account Admin";
      case this.ROLE_CLUSTER_LEAD:
        return "Screening Center Manager";
      case this.ROLE_OPTHALMOLOGY_SUPERVISOR:
        return "Reading Center Manager";
      case this.ROLE_PROGRAM_MANAGER:
        return "Program Manager";
      case this.ROLE_ORGANIZATION:
        return "Operator";
      case this.ROLE_OPHTHALMOLOGY_EXPERT:
        return "Expert";
      case this.ROLE_MANAGEMENT:
        return "Management";
      case this.ROLE_OPERATION:
        return "Operations";
      case this.ROLE_SPECTACLE_ADMIN:
        return "Spectacle Vendor";
      case this.ROLE_QUALITY_AUDITOR:
        return "Quality Auditor";
      case this.ROLE_SPECTACLE_SUPERVISOR:
        return "Spectacle Supervisor";
      case this.ROLE_SUPER_ADMIN:
        return "Super Admin";
      case this.ROLE_TELE_OPTOMETRIST:
        return "Optometrist";
      case this.ROLE_OPERATIONAL_ADMIN:
        return "Operational Admin";
      case this.ROLE_HOSPITAL_OPERATOR:
        return "Refferal Hospital User";
      case this.ROLE_QUALITY_OFFICER:
        return "Quality Officer";
    }
  }

  getUserRolesArrayToString = function (roleName): string {
    let userRolesToReturn: string = "";
    if (roleName != null) {
      let userrolesArray = roleName.split(",");
      if (userrolesArray != null && userrolesArray.length > 0) {
        userrolesArray.forEach(userRole => {
          if (userRole != null && userRole.trim().length > 0) {
            if (userRolesToReturn != null && userRolesToReturn.trim().length > 0)
              userRolesToReturn = userRolesToReturn + ", "
            let userRoleString = this.getRoleNameUsingKey(userRole);
            userRolesToReturn = userRolesToReturn + userRoleString;
          }
        });
      }
    }
    return userRolesToReturn;
  };

  getAvailableWorkflows() {
    return [
      { workFlowId: 1, workFlowName: "MEDICAL_INFO" },
      { workFlowId: 2, workFlowName: "REFRACTION" },
      { workFlowId: 3, workFlowName: "SPECTACLE" },
      { workFlowId: 4, workFlowName: "FUNDUS" },
      { workFlowId: 5, workFlowName: "REFERRAL" },
    ]
  }

  getAddressString(address: Address): string {
    let addressToReturn: string = "";
    var addressInfo = {
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      city: address.city,
      district: address.district,
      state: address.state,
      country: address.country,
      zipcode: address.zipcode
    }
    for (var key in addressInfo) {
      if (addressToReturn.trim().length > 0 && address[key] != null && address[key].trim().length > 0)
        addressToReturn = addressToReturn + ", ";
      if (address[key] != null)
        addressToReturn = addressToReturn + address[key];
    }
    return addressToReturn;
  };

  getDateForServerAPI(convert_date) {
    var new_date = new Date(convert_date);
    new_date.toLocaleDateString()
    new_date.getDate()
    new_date.getMonth()
    new_date.getFullYear()
    var new_date1 = (new_date.getFullYear() + "-" + (((new_date.getMonth() + 1) >= 10) ? (new_date.getMonth() + 1) : '0' + (new_date.getMonth() + 1)) + "-" + (((new_date.getDate()) >= 10) ? (new_date.getDate()) : '0' + (new_date.getDate())));
    return new_date1;
  };
  setDateFormat(format) {
    return window.localStorage.setItem("dateFormat", format);
  };
  getDateFormat() {
    var format = window.localStorage.getItem("dateFormat");
    if (format == null || format == "null") {
      format = "dd-MMM-yyyy hh:mm:ss a";
    }
    return format;
  };
  convertDateCustomFormat(date) {
    if (date != null) {
      //return new Date(date).toString("MM-dd-yyyy hh:mm tt");
      var format = window.localStorage.getItem("dateFormat");
      var formattedDate = new DatePipe(date).transform(format);
      console.log(formattedDate);
      return formattedDate;
    }
    else {
      return "";
    }
  };
  showNotification(message, type): void {
    if ($("[data-notify=container]") != null) {
      $("[data-notify=container]").remove();
    }
    var icon = '';
    if (type == 'success')
      icon = 'fa fa-check';
    else if (type == 'danger')
      icon = 'fa fa-times-circle-o';
    else if (type == 'warning')
      icon = 'fa fa-exclamation-triangle';
    else if (type == 'info')
      icon = 'fa fa-info-circle';
    $.notify({
      message: message,
      icon: icon
    }, {
      type: type
    });
    setTimeout(function () {
      if ($('.animated fadeInDown') != null) {
        $('.animated').removeClass("fadeInDown").addClass("fadeOutUp");
      }
    }, 3000);
  }
  verifyPasswordStrength(password) {
    if (password) {
      password = password.trim();
      var uppercaseLetterPresent = false;
      var lowercaseLetterPresent = false;
      var specialCharacterPresent = false;
      var numberPresent = false;
      var passwordLength = false;
      var arr: String[] = Array.from(password);
      arr.forEach(element => {
        element = element.toString();
        if (element.toString().charCodeAt(0) <= 90 && element.charCodeAt(0) >= 65) {
          uppercaseLetterPresent = true;
        }
        if (element.charCodeAt(0) <= 122 && element.charCodeAt(0) >= 97) {
          lowercaseLetterPresent = true;
        }
        if (element.charCodeAt(0) <= 57 && element.charCodeAt(0) >= 48) {
          numberPresent = true;
        }
        if ((element.charCodeAt(0) <= 47 && element.charCodeAt(0) >= 32) || (element.charCodeAt(0) == 64)) {
          specialCharacterPresent = true;
        }
      });
      if (password.length >= 8) {
        passwordLength = true;
      }
      if (uppercaseLetterPresent && lowercaseLetterPresent && specialCharacterPresent && numberPresent && passwordLength) {
        return true;
      }
      else {
        return false;
      }
    }
    else {
      return false;
    }
  }

  getActiveEnv() {
    return this.activeENV.ACTIVE_ENV;
  }

  getCaptchaSiteKey() {
    // return "6LcgrysrAAAAADKwWz1oW2gag6dhu2AG4Nso4UV_";
    return "6LenNWorAAAAAD3k3kuZkBJrUoDQ2DmQmNTuE6D7";
  }
  getCaptchaV2SiteKey() {
    // return "6Lc-TU4rAAAAAOWBhQoVyv_DsmBieAaqpGnQyJdo";
    return "6LczTmorAAAAAEv8P6LzwdqmPU3Ow84OsFp8Uvr_";
  }
}
